module.exports = __webpack_public_path__ + "static/media/landing-bg.cfe6886b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-bg.jpg
// module id = 51
// module chunks = 0